export default {
	hasChanged_({ selectedRow }) {
		const custCd = selectedRow.custCd || '';
		const oldCustCd = selectedRow.oldCustCd || '';
		return custCd !== oldCustCd;
	},
	isPhotoEditable_({ selectedRow }) {
		return !selectedRow.lgrpCd || selectedRow.lgrpCd === 'PHTG' ? true : false;
	},
	getFormDatas_({ resultList, selectedRow }, getters) {
		const formData = new FormData();
		//업체 변동 시 플레그값 넣어줌
		if (getters.hasChanged_) formData.set('changeCustCd', 'Y');

		// 마스터 데이터 (단 건) 폼데이터 전환
		for (const [key, val] of Object.entries(selectedRow)) {
			if (!val) continue;
			else formData.set(key, val);
		}

		// 디테일 데이터 (다 건) 폼 데이터 전환
		let index = 0;
		for (const result of resultList) {
			for (const [key, val] of Object.entries(result)) {
				if (!val) continue;
				formData.set(`detailList[${index}].${key}`, val);
			}
			index++;
		}
		return formData;
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpNm',
				minWidth: '90px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001122'), //대분류
				prop: 'lgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.lgrpCdList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001123'), //소분류
				prop: 'sgrpCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.sgrpAllList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001213'), //방식
				prop: 'ipnWayCd',
				minWidth: '1px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001215'), //항목
				prop: 'ipnPrvsSbc',
				minWidth: '350px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001243'), //중요도
				prop: 'icrtCd',
				minWidth: '1px'
			},
			{
				label: 'SPEC', //SPEC
				children: [
					{
						label: 'MIN', //MIN
						prop: 'minVal',
						minWidth: '100px'
					},
					{
						label: 'MAX', //MAX
						prop: 'maxVal',
						minWidth: '100px'
					}
				]
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmCd',
				minWidth: '1px',
				form: {
					type: 'select',
					options: state.utmCdList,
					isDisabled: () => !!state.selectedRow.csetDd
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001124'), //단위
				prop: 'utmNm',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001371'), //수치
				prop: 'spcRslt',
				minWidth: '100px'
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001244'), //사진
				prop: 'fwdImgNm',
				minWidth: '150px',
				custom: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC002005'), //주의
				prop: 'mark',
				minWidth: '40px',
				custom: true,
				sortable: true
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001125'), //결과
				prop: 'prvsRsltCd',
				minWidth: '80px',
				form: {
					type: 'select',
					options: state.indvJgmtCdList,
					isDisabled: ({ row }) => {
						if (!state.selectedRow.csetDd) return false;
						else return true;
					}
				}
			}
		];
	}
};
